'use strict';

var _ = require('lodash');
var HistoryDrawerService = function HistoryDrawerService(dataRetrieverService, dataRetrieverConstantsService) {
  function cloneDataRetriever() {
    var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.MARKET_SCREEN, dataRetrieverConstantsService.ADJUSTMENT_HISTORY_MODE);
    return _.cloneDeep(dataRetriever);
  }
  function getObjectId(entityData, adjustmentsHistoryDomain) {
    switch (adjustmentsHistoryDomain) {
      case 'Service':
        return 'ServiceClassPOS-' + entityData.serviceClassId;
      case 'MarketDemand':
        return 'MarketDemandClassGroup-' + [entityData.marketDemandId, entityData.classGroup, entityData.posName].join('.');
      case 'Flight':
        return entityData.segmentClassId ? 'FlightSegmentClass-' + entityData.segmentClassId : entityData.legClassId ? 'FlightLegClass-' + entityData.legClassId : entityData.legCabinId ? 'FlightLegCabin-' + entityData.legCabinId : '';
    }
  }
  function isMergedLegClassSegClassRequest(adjustmentsHistoryDomain, entityData) {
    return adjustmentsHistoryDomain === 'Flight' && entityData.segmentClassId && entityData.legClassId;
  }
  function getFlightLegClassHistory(adjustmentsHistoryDomain, entityData, response) {
    return cloneDataRetriever().selectedParams({
      adjustmentsHistoryDomain: adjustmentsHistoryDomain,
      objectId: 'FlightLegClass-' + entityData.legClassId
    }).localSortApplied().retrieveComponentData('adjustment-history-drawer').then(function (secondaryResponse) {
      return _.chain(response).concat(secondaryResponse).sortBy('date').reverse().value();
    });
  }
  function getHistory(entityData, adjustmentsHistoryDomain) {
    var historyDrawerRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.MARKET_SCREEN, dataRetrieverConstantsService.ADJUSTMENT_HISTORY_MODE);
    var primaryDataRequest = historyDrawerRetriever.selectedParams({
      adjustmentsHistoryDomain: adjustmentsHistoryDomain,
      objectId: getObjectId(entityData, adjustmentsHistoryDomain)
    }).localSortApplied().retrieveComponentData('adjustment-history-drawer');
    return primaryDataRequest.then(function (response) {
      if (isMergedLegClassSegClassRequest(adjustmentsHistoryDomain, entityData)) {
        return getFlightLegClassHistory(adjustmentsHistoryDomain, entityData, response);
      } else {
        return response;
      }
    });
  }
  return {
    getObjectId: getObjectId,
    getHistory: getHistory
  };
};
HistoryDrawerService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = HistoryDrawerService;